import MainItem from './mainItem';
import Items from './items';

const FooterItem = ({
  title,
  icon,
  router,
  isMain,
  isActive = false,
  main,
  isFarm,
  role,
}: TFooterItemType) => {
  return (
    <>
      <div className="flex flex-col items-center  pb-2 pt-2">
        {main ? (
          <MainItem
            isActive={isActive}
            title={title}
            icon={icon}
            isFarm={isFarm}
            router={router}
          />
        ) : (
          <Items
            role={role}
            isActive={isActive}
            title={title}
            icon={icon}
            router={router}
          />
        )}
      </div>
    </>
  );
};

export default FooterItem;
